(() => {
    window.addEventListener("DOMContentLoaded", () => {
        document.querySelector('html').classList.remove('no-js')
        document.querySelector('html').classList.add('js')
    })
}) ()

